import { DomainTranslations, ELocale } from 'App/i18n/i18n.types';

import Domain from 'commons/utils/domains';

import esAR from './save-on-shipping.es-AR.json';
import esMX from './save-on-shipping.es-MX.json';
import ptBR from './save-on-shipping.pt-BR.json';

const saveOnShippingTranslations: DomainTranslations = {
  name: Domain.SAVE_ON_SHIPPING,
  languages: {
    [ELocale.ARGENTINA]: esAR,
    [ELocale.MEXICO]: esMX,
    [ELocale.BRAZIL]: ptBR
  }
};

export default saveOnShippingTranslations;
